import { COLOR_CONSTANTS } from "src/domains/shared/constants/styles";
import {
  LAYER_PANEL_SURFACE_BG,
  SECTION_CARD_RADIUS,
} from "src/domains/shared/components/SideNav/PiledLayerManagement/shared/styles";
import {
  FIELD_BORDER,
  FIELD_DISABLED_BG,
  FOCUS_RING,
  REDUCED_MOTION_SX,
} from "src/domains/shared/components/StateTransition";

export const MYPAGE_SURFACE_BG = LAYER_PANEL_SURFACE_BG;
export const MYPAGE_NAV_BG = "#f7f8fa";
export const MYPAGE_ROW_HOVER_SURFACE = "rgba(0, 0, 0, 0.02)";
export const MYPAGE_CARD_BORDER = "1px solid rgba(0, 0, 0, 0.08)";
export const MYPAGE_ROW_DIVIDER = "1px solid rgba(0, 0, 0, 0.06)";
export const MYPAGE_SECONDARY_ICON = "#9aa0a6";
export const MYPAGE_EMPTY_VALUE = "rgba(0, 0, 0, 0.26)";
export const MYPAGE_DIRTY_DOT = "#f59e0b";
export const MYPAGE_PENDING_CHIP_BG = "#fff4e5";
export const MYPAGE_PENDING_CHIP_TEXT = "#8a5300";
export const MYPAGE_TOGGLE_TRACK_BG = "#eef0f3";
/** 이니셜 아바타 배경 — 멤버 id 로 고르고, 계정 정보 프로필은 첫 색을 쓴다. */
export const MYPAGE_AVATAR_TONES = ["#23374d", "#3b5b7a", "#4a4f8a", "#2f6b5a", "#6b4a3a", "#5a5f66", "#7a4a6b", "#35607d"] as const;

export const MYPAGE_CARD = {
  backgroundColor: COLOR_CONSTANTS.common.white_states.main,
  border: MYPAGE_CARD_BORDER,
  borderRadius: SECTION_CARD_RADIUS,
} as const;

/**
 * 마이페이지 확인·입력 창 공통 규격 — 멤버 삭제 창(`DeleteConfirmDialog`)과 같은 폭 300 · 본문 14px 20px ·
 * 하단 0 20px 16px. 멤버 추가·소유권 이전·로그아웃 확인 창이 같이 쓴다(탈퇴 창은 약관 상자 때문에 폭 400).
 * 스펙 `mypage-project-permission`: 소유권 이전 창은 멤버 추가 창과 같은 규격이어야 한다.
 */
export const MYPAGE_DIALOG_WIDTH_PX = 300;
export const MYPAGE_DIALOG_PAPER_SX = {
  width: MYPAGE_DIALOG_WIDTH_PX,
  maxWidth: "calc(100vw - 32px)",
  borderRadius: "8px",
};
/** 하단 버튼 줄 — 오른쪽 정렬, 취소·실행 8px 간격. */
export const MYPAGE_DIALOG_ACTIONS_SX = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  padding: "0 20px 16px",
};
/** 실행 버튼 최소 폭 — 진행 중 라벨(스피너)로 바뀌어도 버튼 폭이 흔들리지 않게 한다. */
export const MYPAGE_DIALOG_ACTION_MIN_WIDTH_PX = 64;
/** 이메일 입력 placeholder — 형식 예시라 번역하지 않는다. */
export const MYPAGE_EMAIL_PLACEHOLDER = "dronesquare@google.com";
/** 멤버 추가·소유권 이전 창의 이메일 입력 — 오류면 테두리가 오류색이고 포커스 링을 주지 않는다. */
export const myPageEmailInputSx = (hasError: boolean) => ({
  width: "100%",
  height: 32,
  padding: "0 10px",
  borderRadius: "6px",
  border: `1px solid ${hasError ? COLOR_CONSTANTS.error.main : FIELD_BORDER}`,
  outline: "none",
  fontFamily: "inherit",
  fontSize: 13,
  fontWeight: 500,
  color: COLOR_CONSTANTS.text.primary,
  transition: "border-color 150ms ease, box-shadow 150ms ease",
  "&:focus": hasError ? undefined : { borderColor: COLOR_CONSTANTS.primary.main, boxShadow: FOCUS_RING },
  "&:disabled": { backgroundColor: FIELD_DISABLED_BG, color: COLOR_CONSTANTS.text.secondary },
  ...REDUCED_MOTION_SX,
});
